import { gql } from '@apollo/client'

export const FRAGMENT_CREATOR = gql`
  fragment FragmentCreator on Creator {
    id: creatorId
    groupId
    title
    provider
    thumbnail
  }
  fragment FragmentCreatorIncompleteIN on CreatorIncompleteIN {
    title
  }
  fragment FragmentCreatorIncompleteTT on CreatorIncompleteTT {
    title
  }
  fragment FragmentCreatorIncompleteYT on CreatorIncompleteYT {
    title
  }
  fragment FragmentCreatorIncompleteFB on CreatorIncompleteFB {
    title
  }
  fragment FragmentCreatorIncompleteTW on CreatorIncompleteTW {
    title
  }
  fragment FragmentCreatorPublic on CreatorPublic {
    title
  }
`
